<template>
  <div
    class="ui-section-sidebar-item"
    :class="[{ active }, customClass]"
    role="button"
    tabindex="0"
    @click="$emit('click', $event)"
    @keydown.enter.prevent="$emit('click', $event)"
    @keydown.space.prevent="$emit('click', $event)"
  >
    <slot>{{ label }}</slot>
  </div>
</template>

<script>
export default {
  name: 'SectionSidebarItem',
  props: {
    label: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
  emits: ['click'],
};
</script>

<style src="../styles/SectionSidebarItem.css"></style>
